export default __webpack_public_path__ + "static/media/m_b.ab5bd4c5.wav";